import React, { useEffect, useState } from 'react';
import {
  Box,
  SimpleGrid,
  Stat,
  StatLabel,
  StatNumber,
  StatHelpText,
  useColorModeValue,
  Flex,
  Icon,
  Text,
} from '@chakra-ui/react';
import { FaUsers } from 'react-icons/fa';
import { Line, LineChart, ResponsiveContainer, Tooltip, XAxis, YAxis } from 'recharts';
import PageHeader from '../../components/common/PageHeader';
import { useApi } from '../../hooks/useApi';
import { useToast } from '../../hooks/useToast';

export default function AdminDashboard() {
  const [topTenTechs, setTopTenTechs] = useState([]);
  const [branchUsers, setBranchUsers] = useState([]);
  const [departmentUsers, setDepartmentUsers] = useState([]);
  const [totalUsers, setTotalUsers] = useState(0);
  const [totalAvailableUsers, setTotalAvailableUsers] = useState(0);
  const cardBg = useColorModeValue('white', 'gray.800');
  const headerColor = useColorModeValue('orange.500', 'orange.300');

  const { get } = useApi();
  const { showError } = useToast();

  const getTopData = async () => {
    try {
      const response = await get('/common/top-data');

      if (response.isSuccess === false) {
        showError('データの取得に失敗しました');
        return;
      }

      setTopTenTechs(response.data?.topTenTech || []);
      setTotalUsers(response.data?.totalUsers || 0);
      setTotalAvailableUsers(response.data?.totalAvailableUserWithinOneMonth || 0);
      setBranchUsers(response.data?.branchUsersStat || []);
      setDepartmentUsers(response.data?.departmentUsersStat || []);
    } catch (error) {
      showError('データの取得に失敗しました');
    }
  };

  useEffect(() => {
    getTopData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Box px={{ base: 4, md: 10 }} py={8} minH="100vh">
      <PageHeader headerTitle={'管理ダッシュボード'} />

      {/* Stats cards */}
      <SimpleGrid columns={{ base: 1, md: 3 }} spacing={6} mb={10} mt={4}>
        <Stat
          p={6}
          bg={cardBg}
          shadow="lg"
          borderRadius="xl"
          position="relative"
        >
          <Flex align="center" mb={2}>
            <Icon as={FaUsers} boxSize={6} color={headerColor} mr={2} />
            <StatLabel fontSize="lg">{'ユーザー数'}</StatLabel>
          </Flex>
          <StatNumber fontSize="2xl" fontWeight="bold">
            {totalUsers}
          </StatNumber>
          <StatHelpText>トータル</StatHelpText>
        </Stat>

        <Stat
          p={6}
          bg={cardBg}
          shadow="lg"
          borderRadius="xl"
          position="relative"
        >
          <Flex align="center" mb={2}>
            <Icon as={FaUsers} boxSize={6} color={headerColor} mr={2} />
            <StatLabel fontSize="lg">{'参加可能ユーザー数'}</StatLabel>
          </Flex>
          <StatNumber fontSize="2xl" fontWeight="bold">
            {totalAvailableUsers}
          </StatNumber>
          <StatHelpText>これから１月以内</StatHelpText>
        </Stat>
      </SimpleGrid>

      <Text fontSize="xl" mb={4} color={headerColor}>従業員が使用するテクノロジートップ10</Text>
      <ResponsiveContainer width="100%" height={300}>
        <LineChart data={topTenTechs}>
          <XAxis dataKey="technology" />
          <YAxis />
          <Tooltip />
          <Line type="monotone" dataKey="total" stroke="#F6AD55" strokeWidth={2} />
        </LineChart>
      </ResponsiveContainer>

      <Text fontSize="xl" mb={4} color={headerColor} mt={4}>各部署のメンバー数</Text>
      <ResponsiveContainer width="100%" height={300}>
        <LineChart data={departmentUsers}>
          <XAxis dataKey="department" />
          <YAxis />
          <Tooltip />
          <Line type="monotone" dataKey="total" stroke="#F6AD55" strokeWidth={2} />
        </LineChart>
      </ResponsiveContainer>

      <Text fontSize="xl" mb={4} color={headerColor} mt={4}>各支社のメンバー数</Text>
      <ResponsiveContainer width="100%" height={300}>
        <LineChart data={branchUsers}>
          <XAxis dataKey="branch" />
          <YAxis />
          <Tooltip />
          <Line type="monotone" dataKey="total" stroke="#F6AD55" strokeWidth={2} />
        </LineChart>
      </ResponsiveContainer>
    </Box>
  );
}
